module.exports = __webpack_public_path__ + "static/media/background-login.3f9274d0.png";